import React from 'react';
import PropTypes from 'prop-types';
import { LastRowWrapper, LiveLink, CompetitionData } from './styles';
import LabelLink from '../../shared/LabelLink';

const LastRow = ({
  linkLabel1, linkLabel2, linkPath1, linkPath2,
}) =>
  (
    <LastRowWrapper>
      {linkLabel1 &&
        <LiveLink>
          <LabelLink
            label={linkLabel1}
            weight="bold"
            color="linkColor"
            size={0.83}
            path={linkPath1}
          />
        </LiveLink>
      }
      {linkLabel2 &&
        <CompetitionData>
          <LabelLink
            label={linkLabel2}
            weight="bold"
            color="linkColor"
            size={0.83}
            path={linkPath2}
          />
        </CompetitionData>
      }
    </LastRowWrapper>
  );

LastRow.propTypes = {
  linkPath1: PropTypes.any,
  linkPath2: PropTypes.any,
  linkLabel1: PropTypes.string,
  linkLabel2: PropTypes.string,
};

export default LastRow;



// WEBPACK FOOTER //
// ./src/components/shared/LastRow/index.js